<template>
  <div>
    <Messages :messages="messages"/>
    <div class="container" v-if="existsRecord" v-cloak>
      <h2>Consulta de constancias electrónicas</h2>
      <br/>
      <div class="bg-secondary text-white font-weight-bold px-3 py-2 rounded d-inline-block">
        Datos del alumno
      </div>
      <hr>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Matrícula:"
                    label-for="input-sm">
        <b-form-input id="studentNameId" size="sm"
                      v-bind:value="recordData.idEnrollment"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Nombre:"
                    label-for="input-sm">
        <b-form-input id="studentNameId" size="sm"
                      v-bind:value="recordData.studentName"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Institución educativa:"
                    label-for="input-sm">
        <b-form-input id="educationalInstitutionId" size="sm"
                      v-bind:value="recordData.educationalInstitution"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Carrera:"
                    label-for="input-sm">
        <b-form-input id="programId" size="sm"
                      v-bind:value="recordData.program"
                      readonly>
        </b-form-input>
      </b-form-group>
            <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Promedio general:"
                    label-for="input-sm">
        <b-form-input id="averageId" size="sm"
                      v-bind:value="(!recordData.average || recordData.average.toLowerCase() === 'null') ? '—' : recordData.average"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Materias aprobadas:"
                    label-for="input-sm">
        <b-form-input id="coursesId" size="sm"
                      v-bind:value="recordData.totalCourses && recordData.requiredCourses ? recordData.totalCourses + ' de ' + recordData.requiredCourses : '—'"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Porcentaje de avance:"
                    label-for="input-sm">
        <b-form-input id="percentageId" size="sm"
                      :value="recordData.percentage && recordData.percentage !== 'null'
                              ? (Number(recordData.percentage) === 100
                                  ? '100%'
                                  : recordData.percentage + '%')
                              : '—'"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Tipo de constancia:"
                    label-for="input-sm">
        <b-form-input id="recordTypeId" size="sm"
                      v-bind:value="recordData.recordType"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Folio:"
                    label-for="input-sm">
        <b-form-input id="folioId" size="sm"
                      v-bind:value="recordData.folio"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Fecha de expedición:"
                    label-for="input-sm">
        <b-form-input id="issuedDateId" size="sm"
                      v-bind:value="recordData.issuedDate"
                      readonly>
        </b-form-input>
      </b-form-group>
      <div class="row">
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Messages from "../components/Messages.vue"

export default {

  components: {
    Messages
  },

  data: () => ({
    existsRecord: false,
    recordData: {},
    showLoader: false,
    messages: {
      info: "",
      error: "",
      warning: ""
    }
  }),

  computed: {
    ...mapGetters({
      record: "record/record",
    }),
  },

  mounted () {
    this.initialize()
  },

  methods: {
    initialize () {
      console.log("Record in URL" + this.$route.query.folio)
      this.showLoader = true,
      this.$store
            .dispatch("record/getRecordUser", this.$route.query.folio)
            .then((response) => {
              this.recordData = response
              this.existsRecord = response != null ? true : false
              this.showLoader = false
            })
            .catch( error => {
              console.log(error)
              this.messages.info = "Constancia no encontrada."
              this.existsRecord = false
              this.showLoader = false
            })
    },
  }
}
</script>